import * as React from "react";

export class EventLink extends React.Component<{ href: string, handler: Function, dataUat:string, modifier?: string }, {}> {

    render() {
        const baseCls = "rj-sports-multiview__event-link";
        const cls = this.props.modifier ? `${baseCls} ${this.props.modifier}` : baseCls;
        return (
            <a href={this.props.href} onClick={(event) => this.props.handler(event)} data-uat={this.props.dataUat} className={cls} >
                {this.props.children}
            </a>
        )
    }
}